import TenDaysMVPBanner from './TenDaysMVPBanner';
export default TenDaysMVPBanner;
